<template>
  <div class="shape shape--inline" v-if="iconList">
    <div class="shape__group" v-for="icon in iconList" :key="icon">
      <input class="shape__input" type="radio" :id="icon" :value="icon" @click="updateValue">
      <label :class="[`shape__label shape__label--${icon}-icon`, { 'shape__label--active': icon === modelValue }]" :for="icon"></label>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { v4 as uuid } from 'uuid';

const props = defineProps({
  iconList: { type: Array, default: () => [] },
  id: { type: String, default: uuid },
  modelValue: { type: String, default: '' },
});

const emit = defineEmits(["update:modelValue"]);

const updateValue = (event) => {
  emit("update:modelValue", event.target.value);
};
</script>

<style lang="scss">
@import '@/stylesheets/global';

.shape {
  &--inline {
    display: flex;
    flex-wrap: wrap;
  }

  &--error {
    .shape__label {
      &::before {
        border: 1px solid map-get($error-color, default);
      }
    }
  }

  &__group {
    position: relative;
    width: bu(6);
    height: bu(6);
    margin-bottom: bu(2.5);

    &:not(:last-child) {
      margin-right: bu(2.5);
    }
  }

  &__input {
    display: none;
  }

  &__label {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: 400;

    &--circle-icon::before {
      background-image: url('@/images/shaft/shaft_circle.svg');
    }

    &--circles-icon::before {
      background-image: url('@/images/shaft/shaft_circles.svg');
    }

    &--rectangle-icon::before {
      background-image: url('@/images/shaft/shaft_rectangle.svg');
    }

    &--squircle-icon::before {
      background-image: url('@/images/shaft/shaft_squircle.svg');
    }

    &--active::before {
      border: 1px solid map-get($foreground-color, default);
    }

    &::before {
      content: '';
      width: bu(6);
      height: bu(6);
      border-radius: map-get($border-radius, heavy);
      background-position: center, center;
      background-repeat: no-repeat;
      background-size: cover;
      display: block;
      flex-shrink: 0;
      margin-right: bu(2);
    }
  }
}
</style>
